import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                marginTop: (props: MobileContentProps) =>
                    !props.hasTabs && !props.hasStatusLabel
                        ? 0
                        : props.hasStatusLabel
                        ? theme.relode.sizes.mobileHeaderHeight +
                          theme.relode.sizes.mobileHeaderStatusLabelHeight +
                          theme.spacing(3)
                        : theme.relode.sizes.mobileHeaderStatusLabelHeight +
                          theme.spacing(3),
                flexGrow: 1,
                // paddingLeft: 16,
                // paddingRight: 16,
                height: "100%",
                width: "100%",
            },
        }),
    { name: "MobileContent" }
);

interface MobileContentProps {
    children?: React.ReactNode;
    hasTabs: boolean;
    hasFooter: boolean;
    hasStatusLabel: boolean;
}

export const MobileContent = (props: MobileContentProps) => {
    const classes = useStyles(props);
    return <div className={classes.root}>{props.children}</div>;
};
